/**
 * NOS-249: public-site origin + hostname→org resolution, extracted as the
 * single renderer-agnostic source of truth (previously duplicated between
 * src/lib/publicSiteUrl.ts and supabase/functions/sitemap/lib.ts).
 *
 * Host resolution itself is canonical in `@nos/host-resolution`
 * (packages/host-resolution, NOS-247); it is re-imported here via a
 * relative `.ts` path so the Supabase sitemap function (Deno) can follow
 * the chain without bare workspace specifiers. Keep every import in this
 * file relative + `.ts`-extensioned for that reason.
 */

import { ROOT_DOMAIN } from "../../../packages/host-resolution/src/index.ts"

export {
  ROOT_DOMAIN,
  RESERVED_SUBDOMAINS,
  resolveHost,
  type HostResolution,
} from "../../../packages/host-resolution/src/index.ts"

/**
 * Canonical public site origin for SEO/sitemaps: verified custom domain,
 * else org subdomain.
 */
export function publicSiteOrigin(org: {
  slug: string
  custom_domain?: string | null
}): string {
  const custom = org.custom_domain?.trim().toLowerCase()
  if (custom) return `https://${custom}`
  return `https://${org.slug.toLowerCase()}.${ROOT_DOMAIN}`
}
